function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.16
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M371 149.648v331.704C371 504.81 351.884 524 328.5 524c-23.375 0-42.5-19.182-42.5-42.648V149.648C286 126.19 305.125 107 328.5 107c23.384 0 42.5 19.191 42.5 42.648M85 42.76v316.48C85 382.747 65.875 402 42.5 402 19.116 402 0 382.748 0 359.24V42.76C0 19.243 19.116 0 42.5 0 65.875 0 85 19.242 85 42.76M228 147.704v103.592C228 274.783 208.875 294 185.5 294c-23.384 0-42.5-19.217-42.5-42.704V147.704C143 124.217 162.116 105 185.5 105c23.375 0 42.5 19.217 42.5 42.704",
  transform: "translate(-653 -364) translate(653 364)"
}))));

function SvgLogoGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 371,
    height: 524,
    viewBox: "0 0 371 524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGroup);
export default __webpack_public_path__ + "static/media/logo-group.6c8c8112.svg";
export { ForwardRef as ReactComponent };